import { Alert, Link } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React, { useEffect, useState } from 'react'
import { useAnalytics } from '../analytics/analytics-context'
import { useApplicationContext } from '../../../context/ApplicationContext'

function UpgradeHubAlertError() {
  const context = useApplicationContext()
  const { trackShown, trackPress } = useAnalytics()

  const [isVisible, setIsVisible] = useState(true)

  const closeAlert = () => {
    setIsVisible(false)
  }

  const createOnClick = (linkName) => () => {
    trackPress({
      component: 'alert-link',
      linkName,
      redirectUrl: 'https://developer.paypal.com/upgrade/guide/',
    })
  }

  const treatmentName = context.upgradehub_v2
  const experimentName = treatmentName.split('_').slice(1).join('_')
  useEffect(
    function () {
      if (isVisible) {
        trackShown({
          component: 'alert',
          alertType: 'error',
          treatmentName,
          experimentName,
        })
      }
    },
    [isVisible],
  )

  if (!isVisible) {
    return null
  }

  return (
    <Alert
      type="warning"
      data-testid="upgrade-hub-alert-error"
      closeButton={{
        'aria-label': 'dismiss alert',
        onClick: closeAlert,
      }}
    >
      <Message
        id="upgrade-hub.error"
        link={(label) => (
          <Link
            onClick={createOnClick(label)}
            target="_blank"
            href={`https://developer.paypal.com/upgrade/guide/`}
          >
            {label}
          </Link>
        )}
      />
    </Alert>
  )
}

export default UpgradeHubAlertError
